import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(
      "w-[42px] h-[25px] bg-input relative shadow-[0_2px_10px_var(--input-border)] rounded-full focus:shadow-[0_0_0_2px_var(--input-border)] !outline-none",
      "data-[state=checked]:bg-secondary",
      className,
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        "block w-[21px] h-[21px] bg-[white] shadow-[0_2px_2px_var(--secondary)] transition-transform duration-100 translate-x-0.5 will-change-transform rounded-full",
        "data-[state=checked]:translate-x-[19px]",
      )}
    />
  </SwitchPrimitive.Root>
));
Switch.displayName = SwitchPrimitive.Root.displayName;

export { Switch };
